import Location from "@/scenes/location";
import GameApp from "../../../index";

export class ClearSceneHandler {
  static async handle(data: {
    name: any;
    tilemap: any;
    furnitures: any;
    owner: any;
  }) {
    const { name, tilemap, furnitures, owner } = data;

    await this.handleJoin(name, tilemap, furnitures, owner);
  }

  private static async handleJoin(
    name: string,
    tilemap: any,
    furnitures: any,
    owner: any
  ) {
    const location = new Location({
      tilemap,
      preloadFurnitures: { furnitures },
      ownerId: owner.userId,
    });

    if (GameApp.game.scenes[name]) {
      await GameApp.game.goToScene("root");

      GameApp.game.remove(name);
    }

    GameApp.game.add(name, location);
    await GameApp.game.goToScene(name);

    const scene = GameApp.game.currentScene as Location;
    scene?.locationInfo?.setOwner(owner);
    scene?.locationInfo?.setTitle(name);
  }
}
